



































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { Step } from '@attensi/api-js';

@Component
export default class MileStone extends Vue {
  collapsed: boolean = false;

  @Prop({ required: true })
  milestone!: any;

  @Getter('processModule/activeStep') activeStep!: Step;
  @Action('processModule/setActiveStep') setActiveStep!: Function;


  get isMileStoneSeleted() {
    return this.milestone.steps.includes(this.activeStep);
  }

  toggleCollapsed() {
    this.collapsed = !this.collapsed;
    if (!this.collapsed) {
      this.setActiveStep(this.milestone.steps[0]);
    }
  }

}
